/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface DetailedShipList
 */
export interface DetailedShipList {
    /**
     * The groups that the shiplist is shared with
     * @type {Array<string>}
     * @memberof DetailedShipList
     */
    acl?: Array<string>;
    /**
     * The id of the shiplist
     * @type {string}
     * @memberof DetailedShipList
     */
    id?: string;
    /**
     * The color that the shiplist ships get
     * @type {string}
     * @memberof DetailedShipList
     */
    color?: string;
    /**
     * The name of the shiplist. Notice this name must be unique for the owner and all users affected by the ACL
     * @type {string}
     * @memberof DetailedShipList
     */
    name?: string;
    /**
     * Max number of ships in the shiplist for user modifiable lists.
     * @type {number}
     * @memberof DetailedShipList
     */
    max?: number;
    /**
     * Who own the shape
     * @type {string}
     * @memberof DetailedShipList
     */
    owner?: string;
    /**
     * The actual list of ships. MMSI, IMO, Name and Callsign can be used.
     * @type {Array<Ship>}
     * @memberof DetailedShipList
     */
    ships?: Array<Ship>;
}

/**
 * Check if a given object implements the DetailedShipList interface.
 */
export function instanceOfDetailedShipList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DetailedShipListFromJSON(json: any): DetailedShipList {
    return DetailedShipListFromJSONTyped(json, false);
}

export function DetailedShipListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailedShipList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'ships': !exists(json, 'ships') ? undefined : ((json['ships'] as Array<any>).map(ShipFromJSON)),
    };
}

export function DetailedShipListToJSON(value?: DetailedShipList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acl': value.acl,
        'id': value.id,
        'color': value.color,
        'name': value.name,
        'max': value.max,
        'owner': value.owner,
        'ships': value.ships === undefined ? undefined : ((value.ships as Array<any>).map(ShipToJSON)),
    };
}

